<div class="screenshot-toast">
    <aside  *ngFor="let message of messages" (click)="removeMessage(message)">
      <div class="screenshot-toast__notification" [ngClass]="{'screenshot-toast__notification--black': message.style==='info'}">
        {{message.content}}
      </div>
    </aside>
  </div>